import { ContentfulPageSectionStyle } from '@typings/contentful-page-section-template'
import { Container } from '@ui/container'
import clsx from 'clsx'
import React, { type FC, type ReactNode } from 'react'

import { type SectionProps } from './section-template'
import SectionTemplateIconic1 from './section-template-iconic-1'
import SectionTemplateIconic2 from './section-template-iconic-2'

const ICONIC_CLASS =
  'is-iconic !pb-0 !laptop:pb-0 !pt-0 !laptop:pt-0 text-[#FFFFFF]'

const ClassBackGroundMapper: Partial<
  Record<ContentfulPageSectionStyle | string, string>
> = {
  [ContentfulPageSectionStyle.REFRESH_WHITE_BACKGROUND]:
    'is-white bg-[#FFFFFF]',
  [ContentfulPageSectionStyle.REFRESH_BLUE_BACKGROUND]:
    'is-blue bg-[radial-gradient(101.57%_141.42%_at_100%_100%,_#0C3942_0%,_#17535F_100%)]',
  [ContentfulPageSectionStyle.REFRESH_GRADIENT_BACKGROUND]:
    'is-gradient relative [background:radial-gradient(50%_45%_at_80%_120%,_#B0EB64_-40%,_rgba(255,_255,_255,_0)_100%),_radial-gradient(50%_45%_at_20%_120%,_#ABD9FF_-40%,_rgba(255,_255,_255,_0)_100%),_#FFF] laptop:[background:radial-gradient(45%_50%_at_60%_120%,_#B0EB64_-40%,_rgba(255,_255,_255,_0)_100%),_radial-gradient(45%_50%_at_40%_120%,_#ABD9FF_-40%,_rgba(255,_255,_255,_0)_100%),_#FFF] laptopL:[background:radial-gradient(28%_50%_at_60%_120%,_#B0EB64_-40%,_rgba(255,_255,_255,_0)_100%),_radial-gradient(28%_50%_at_40%_120%,_#ABD9FF_-40%,_rgba(255,_255,_255,_0)_100%),_#FFF]',
  [ContentfulPageSectionStyle.REFRESH_GREY_BACKGROUND]: 'is-grey bg-[#F7F7F7]',
  [ContentfulPageSectionStyle.PREMIUM_BLACK]:
    'is-premium-black bg-[#000000] text-[#FFFFFF]',
  [ContentfulPageSectionStyle.ICONIC_1]: ICONIC_CLASS,
  [ContentfulPageSectionStyle.ICONIC_2]: ICONIC_CLASS,
}

const IconicBackGroundComponentsMapper: Partial<
  Record<
    ContentfulPageSectionStyle | string,
    React.FC<{ className: string } & { children?: ReactNode }>
  >
> = {
  [ContentfulPageSectionStyle.ICONIC_1]: SectionTemplateIconic1,
  [ContentfulPageSectionStyle.ICONIC_2]: SectionTemplateIconic2,
}

const SectionTemplateBackground: FC<SectionProps> = ({
  isEmpty,
  style,
  children,
}) => {
  const SpecificColorClasses = ClassBackGroundMapper[style]
  const Component = IconicBackGroundComponentsMapper[style] || Container
  return (
    <div
      className={clsx(
        'is-refresh group/section-template flex h-full w-full justify-center pt-[72px] laptop:pt-[120px]',
        isEmpty ? 'pb-0' : 'pb-[72px] laptop:pb-[120px]',
        SpecificColorClasses
      )}
    >
      <Component className="px-4 laptop:px-[132px]">{children}</Component>
    </div>
  )
}

export default SectionTemplateBackground
